var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('van-field', {
    staticClass: "inputs",
    attrs: {
      "value": _vm.value,
      "center": "",
      "clearable": "",
      "type": "digit",
      "placeholder": "请输入验证码"
    },
    on: {
      "input": _vm.setInputValue
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function () {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.isget,
            expression: "isget"
          }],
          staticClass: "button",
          on: {
            "click": _vm.handleGetCode
          }
        }, [_vm._v("获取验证码")]), _c('van-count-down', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: !_vm.isget,
            expression: "!isget"
          }],
          ref: "countDown",
          staticClass: "button",
          attrs: {
            "auto-start": false,
            "millisecond": "",
            "time": _vm.time,
            "format": "ss"
          },
          on: {
            "finish": _vm.finish
          }
        })];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };